<div class="wrapper">
  <h2 class="header">{{ header }}</h2>
  <div class="info">
    <mat-list>
      <mat-list-item
        >Дата: {{ date.toLocaleDateString() }} {{ date.toLocaleTimeString() }}</mat-list-item
      >
      <mat-list-item> Остаток в кассе : {{ supportService.formatMoney(sum) }} </mat-list-item>
    </mat-list>
  </div>
</div>
